export default "__VITE_ASSET__DQDliXl2__"